import React from "react";
import HeaderComponent from "../Registration/Components/HeaderComponent";
import CancellationOBDForm from "./Forms/CancellationOBDForm";
const CancellationOBD = () => {
  return (
    <div
      className="customerinformation"
      // ref={(el) => {
      //   if (el) {
      //     el.style.setProperty("background", background, "important");
      //   }
      // }}
    >
      <HeaderComponent />
      <div className="container content">
        <div className="row">
          <div className="customerform_left col-lg-5">
            <h1>Cancel device!</h1>
          </div>
          <div className="customerform_right col-lg-7">
            <CancellationOBDForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationOBD;
